module.exports = __webpack_public_path__ + "static/media/playing.e20a86f4.jpg";